package com.macrofocus.common.collection

actual class SoftReference<T> actual constructor(val referent: T) {
    actual fun get(): T? {
        return referent
    }
}